import styles from './editETLComponentForm.module.scss';

interface TpParamSet {
  params: { id?: string; name: string; component: any }[];
}

function ParamSet({ params }: TpParamSet) {
  return (
    <div>
      {params.map((param, index) => (
        <div key={param.id || `param_${index}`} className={styles.keyValSet}>
          <div className={styles.keyValSetKey}>{param.name}:</div>
          <div className={styles.keyValSetVal}>{param.component}</div>
        </div>
      ))}
    </div>
  );
}

export default ParamSet;
